import request from "@user-center/utils/request";
import setUrl from "@user-center/utils/setUrl";
import type { AxiosPromise } from "axios";

let frontServiceUrl="/frontserver";
 
export type FeedbackStatus = "open" | "processing" | "resolved" | "closed";


//获取用户信息
export function modfiyActivePage(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/manage/activityPage/modfiyActivePage", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

//获取仓库包裹
export function getMemberPackageList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/member-package/query/page-list", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

//获取优惠卷
export function queryPageCouponList(data: any, headers?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/userCoupon/queryPageList", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
    headers: {
      ...headers,
    },
  });
}

//获取应付账单
export function queryUnpaidOrderStats(data: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryUnpaidOrderStats", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

// 用户中心首页聚合数据
export function queryIndexInfoByH5(data?: any): AxiosPromise<unknown> {
  return request({
    url: `/jyUserOrder/queryIndexInfoByH5?d=${Date.now()}`,
    method: "post",
    data: { ...data },
  });
}

// 获取充值详情
export function getRechargeDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallGoods/itemSpuDetail", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

 
// 获取店铺汇率列表
export function getShopRateApi(data: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/dealerShopCurrencyRate/queryPageList", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

// 计算汇率
export function getShopRateCalc(data: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/dealerShopCurrencyRate/calculate", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


// 提交线下充值
export function applyOfflineRecharge(data) {
  return request({
    url: "/portal/offlineRecharge/apply", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });

}

 
// 线下充值申请记录
export function queryOfflineRechargeApplyOnPage(data) {
  return request({
    url: "/portal/offlineRecharge/queryOfflineRechargeApplyOnPage", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });

}

// H5 获取店铺支付方式
export function geyShopPayMode(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/dealerShopPaymentConfig/queryPageList", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


export function createRechargeOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallOrder/confirmOrder?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


export function createRechargePayOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallOrder/createOrder?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

// 根据订单编码查询采购支付单
export function queryPurchaseOrderByCode(data: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryPurchaseOrderByCode?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

// 采购单支付
export function payJyUserPurchaseMallOrderV2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/purchasepay/v2?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

// 集运订单支付
export function payJyUserOrderV2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/pay/v2?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

// 集运订单详情
export function queryCollectionOrderById(data: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryOrderById?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

 //  合并支付
export function paymentOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallOrder/paymentOrder?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

 //  合并支付
 export function getH5weChatPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallOrder/getQrCode?untransfer=true", // 配置url
    method: "get", // 配置请求方式
    params: { ...data },
    responseType: "arraybuffer"
  },{
    returnAll:true,
    
  });
}


// 查询支付结果
export function queryRechargeType(data: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/mallOrder/queryMiniProgramPayOrderByBizTradeId?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


// 申请预报
export function packageForecast(data: any): AxiosPromise<unknown> {
  return request({
    url: "/member-package/save?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

// 当前店铺币种
export function queryCurrentShopCurrency(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/dealerShop/queryCurrentShop",
    method: "post",
    data: { ...data },
  });
}

export function createFeedback(data: {
  appType: string;
  title: string;
  introduction?: string;
  memberCode?: string;
  picUrls?: string;
  shopId?: string | number;
}): AxiosPromise<unknown> {
  return request({
    url: `${frontServiceUrl}/feedback/create`,
    method: "post",
    data: { ...data },
  });
}

export function listFeedbacks(data: {
  appType?: string;
  memberCode?: string;
  shopId?: string | number;
  status?: FeedbackStatus;
  page?: number;
  pageSize?: number;
}): AxiosPromise<unknown> {
  return request({
    url: `${frontServiceUrl}/feedback/list`,
    method: "post",
    data: { ...data },
  });
}

export function createFeedbackMessage(data: {
  feedbackId: number | string;
  senderType?: "user" | "admin" | "system";
  senderId?: string;
  message: string;
  attachments?: string;
}): AxiosPromise<unknown> {
  return request({
    url: `${frontServiceUrl}/feedback/message/create`,
    method: "post",
    data: { ...data },
  });
}

export function listFeedbackMessages(data: {
  feedbackId: number | string;
  page?: number;
  pageSize?: number;
}): AxiosPromise<unknown> {
  return request({
    url: `${frontServiceUrl}/feedback/message/list`,
    method: "post",
    data: { ...data },
  });
}

// 集运钱包信息
export function queryCollectionFundInfo(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/fundInfo/queryByUserId",
    method: "post",
    data: { ...data },
  });
}

// 集运积分
export function queryCollectionUserIntegral(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryUserIntegral",
    method: "post",
    data: { ...data },
  });
}

// 集运优惠券
export function queryCollectionUserCouponList(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryUserCouponList",
    method: "post",
    data: { ...data },
  });
}

// 集运试算金额
export function queryCollectionOrderPayAmountV2(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryOrderPayAmount/v2",
    method: "post",
    data: { ...data },
  });
}

// 集运目的国配置
export function queryCollectionSettlementDestCountryConfig(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/destCountryConfig/queryByName",
    method: "post",
    data: { ...data },
  });
}

// 集运地址校验
export function collectionCustomerVerify(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/customerVerify",
    method: "post",
    data: { ...data },
  });
}

// 创建集运订单
export function createCollectionOrderV2(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/createOrder/v2",
    method: "post",
    data: { ...data },
  });
}

// 集运服务产品
export function queryCollectionProducts(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/dealerShopServiceProduct/queryProductList",
    method: "post",
    data: { ...data },
  });
}

// 集运联动选项
export function queryCollectionSelectList(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/dealerShopServiceProduct/querySelectList?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

export function getAppShareList(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/appShare/appShareList",
    method: "post",
    data: { ...data },
  });
}

// 集运处理方式
export function queryCollectionOrderProcessedList(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/jyUserOrder/queryOrderProcessedList",
    method: "post",
    data: { ...data },
  });
}

// 集运地址
export function getDefaultAddress(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/addressManage/getDefault?untransfer=true",
    method: "post",
    data: { ...data },
  });
}

export function getAddressListForCollection(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/admin/addressManage/list?untransfer=true",
    method: "post",
    data: { ...data },
  });
}





// 图片验证码
export function getImgCodeApi(data: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/auth/getImgCode?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


// 图片验证码
export function validateImgCode(data: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/auth/validateImgCode?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


 

// 发送短信验证码
export function sendSmsCode(data: any): AxiosPromise<unknown> {
  return request({
    url: "/portal/auth/sendSmsCode?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


// 获取包裹图片
export function getImagePaths(data: any): AxiosPromise<unknown> {
  return request({
    url: "../platform/member-package/getImagePaths?untransfer=true", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}

// 獲取錯誤提示
export function queryUserPackageNoticeMsgApi(data: any): AxiosPromise<unknown> {
  return request({
    url: "/customerInfo/queryUserPackageNoticeMsg", // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}



export function isUpdateing(data: any): AxiosPromise<unknown> {
  return request({
    url: frontServiceUrl + "/platformSystemState/state",  // 配置url
    method: "post", // 配置请求方式
    data: { ...data },
  });
}


 
















export const getQrCodeUrl=setUrl()+"/admin/mallOrder/getQrCode?untransfer=true"

 
